<template>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90.07 90.07">
  <g>
    <path class="cls-4" d="m34.5,25.15c-.28,0-.5-.22-.5-.5v-6.07l-13.92-3.38c-.27-.07-.43-.34-.37-.6s.33-.43.6-.37l14.68,3.57v6.86c0,.28-.22.5-.5.5Z"/>
    <path class="cls-1" d="m26.5,43.74c-.23,0-.45-.08-.62-.22-.24-.19-.38-.48-.38-.78v-22.85c0-.47.33-.88.79-.98l15.99-3.42c.3-.07.6,0,.84.2.23.19.37.48.37.78v22.67c0,.47-.32.87-.78.98l-15.99,3.6c-.07.02-.15.02-.22.02Zm1-23.04v20.79l13.99-3.15v-20.63l-13.99,2.99Z"/>
    <g>
      <polygon class="cls-1" points="26.5 42.74 26.5 19.9 10.51 16.48 10.51 39.15 26.5 42.74"/>
      <path class="cls-1" d="m26.5,43.74c-.07,0-.15,0-.22-.02l-15.99-3.6c-.46-.1-.78-.51-.78-.98v-22.67c0-.3.14-.59.37-.78.24-.19.54-.27.84-.2l15.99,3.42c.46.1.79.51.79.98v22.85c0,.3-.14.59-.38.78-.18.14-.4.22-.62.22Zm-14.99-5.4l13.99,3.15v-20.79l-13.99-2.99v20.63Z"/>
    </g>
    <path class="cls-1" d="m42.5,17.48c-.06,0-.13,0-.19-.02l-15.37-2.96-16.25,2.96c-.54.11-1.06-.26-1.16-.8-.1-.54.26-1.06.8-1.16l16.44-2.99c.12-.02.25-.02.37,0l15.55,2.99c.54.1.9.63.79,1.17-.09.48-.51.81-.98.81Z"/>
  </g>
  <g>
    <rect class="cls-3" x="64.31" y="51.19" width=".54" height="25.59"/>
    <path class="cls-3" d="m74.35,77.32h-19.55c-1.96,0-3.56-1.6-3.56-3.56v-19.55c0-1.96,1.6-3.56,3.56-3.56h19.55c1.96,0,3.56,1.6,3.56,3.56v19.55c0,1.96-1.6,3.56-3.56,3.56Zm-19.55-25.59c-1.37,0-2.48,1.11-2.48,2.48v19.55c0,1.37,1.11,2.48,2.48,2.48h19.55c1.37,0,2.48-1.11,2.48-2.48v-19.55c0-1.37-1.11-2.48-2.48-2.48h-19.55Z"/>
    <g>
      <g>
        <path class="cls-2" d="m71.93,59.59c-.11,0-.22.02-.3.09-.87.65-2.07,1.05-3.39,1.05s-2.54-.41-3.41-1.07c-.07-.05-.17-.08-.26-.08v-11.66h6.66l.7,11.67Z"/>
        <path class="cls-6" d="m68.25,60.91c-1.33,0-2.58-.39-3.52-1.1-.04-.03-.09-.04-.15-.04h-.18v-12.02h7l.72,12.03h-.2c-.07-.01-.14.01-.18.04-.94.7-2.18,1.09-3.5,1.09Zm-3.49-1.48c.07.02.13.05.19.09.88.67,2.05,1.03,3.3,1.03s2.4-.36,3.28-1.02c.06-.05.13-.08.22-.1l-.68-11.33h-6.31v11.33Z"/>
      </g>
      <g>
        <path class="cls-2" d="m57.91,47.92l-.7,11.67c-.09,0-.18.03-.25.09-.87.65-2.07,1.05-3.39,1.05-.11,0-.22,0-.33,0-2.97-.15-4.93-2.41-4.1-4.56l.36-.95,2.57-6.71c.13-.35.55-.59,1.04-.59h4.8Z"/>
        <path class="cls-6" d="m53.57,60.91c-.11,0-.23,0-.34,0-1.69-.09-3.16-.84-3.93-2.03-.56-.86-.68-1.85-.32-2.77l2.93-7.65c.16-.42.64-.7,1.2-.7h4.99l-.72,12.02h-.16c-.06,0-.11.03-.15.06-.93.7-2.17,1.09-3.49,1.09Zm-.46-12.81c-.41,0-.76.19-.87.47l-2.93,7.65c-.31.81-.21,1.68.29,2.45.71,1.09,2.08,1.79,3.65,1.87.11,0,.22,0,.32,0,1.24,0,2.41-.36,3.28-1.01.06-.04.12-.07.19-.09l.68-11.34h-4.61Z"/>
      </g>
      <path class="cls-4" d="m64.58,47.92v11.66c-.1,0-.19.02-.26.08-.87.66-2.07,1.07-3.41,1.07s-2.52-.4-3.38-1.05c-.09-.06-.2-.09-.31-.09l.7-11.67h6.67Z"/>
      <path class="cls-4" d="m75.92,60.72c-.11,0-.22,0-.33,0-1.32,0-2.52-.4-3.39-1.05-.07-.05-.17-.08-.27-.09l-.7-11.67h4.84c.46,0,.87.23,1,.56l2.58,6.73.36.95c.82,2.15-1.14,4.41-4.1,4.56Z"/>
    </g>
    <path class="cls-3" d="m67.05,67.74c-.25,0-.45-.2-.45-.45v-2.05c0-.25.2-.45.45-.45s.45.2.45.45v2.05c0,.25-.2.45-.45.45Z"/>
    <path class="cls-3" d="m62.33,67.74c-.25,0-.45-.2-.45-.45v-2.05c0-.25.2-.45.45-.45s.45.2.45.45v2.05c0,.25-.2.45-.45.45Z"/>
    <path class="cls-3" d="m75.59,61.09c-1.35,0-2.63-.4-3.6-1.12-.03-.02-.11-.02-.14,0-.97.73-2.25,1.12-3.6,1.12s-2.65-.41-3.62-1.14c-.02-.01-.08-.01-.1,0-.97.74-2.26,1.14-3.62,1.14s-2.63-.4-3.6-1.12c-.03-.02-.11-.02-.13,0-.97.72-2.25,1.12-3.6,1.12-.12,0-.23,0-.35,0-1.75-.09-3.27-.88-4.08-2.12-.59-.91-.71-1.95-.34-2.93l2.93-7.66c.19-.49.74-.81,1.37-.81h22.97c.61,0,1.15.32,1.33.79l2.94,7.68c.37.98.25,2.02-.34,2.93-.8,1.23-2.33,2.03-4.08,2.11-.12,0-.23,0-.35,0Zm-3.67-1.86c.18,0,.36.05.5.16.84.63,1.97.98,3.17.98.1,0,.21,0,.31,0,1.52-.08,2.83-.75,3.51-1.79.47-.72.56-1.53.27-2.28l-2.94-7.68c-.06-.17-.31-.34-.67-.34h-22.97c-.33,0-.62.15-.7.36l-2.93,7.65c-.29.76-.19,1.57.27,2.28.68,1.04,1.99,1.71,3.52,1.79.1,0,.21,0,.31,0,1.2,0,2.33-.35,3.17-.98.28-.21.71-.21.99,0,.84.63,1.97.98,3.17.98s2.34-.35,3.19-1c.27-.21.68-.21.96,0,.85.64,1.98,1,3.19,1s2.33-.35,3.17-.98c.14-.11.32-.16.5-.16Z"/>
  </g>
  <path class="cls-5" d="m17.27,77.59c-.51,0-1.02-.2-1.41-.59-.78-.78-.78-2.05,0-2.83l57.58-57.58c.78-.78,2.05-.78,2.83,0,.78.78.78,2.05,0,2.83l-57.58,57.58c-.39.39-.9.59-1.41.59Z"/>
</svg>
</template>

<script>
export default {
    name: "RMAVsROMTimelineIcon",
}
</script>

<style scoped>
  .cls-1 {
    fill: #155e74;
  }
  .cls-2 {
    fill: #b3decd;
  }
  .cls-3 {
    fill: #115c72;
  }
  .cls-4 {
    fill: #59c5c7;
  }
  .cls-5 {
    fill: #cfeae0;
  }
  .cls-6 {
    fill: #135d73;
  }
</style>